<div *ngIf="!isDismissed" class="badge" [class.small]="small" [class.no-text-mobile]="noTextMobile"
[class.dot]="dot">
  <div class="badge-text" *ngIf="!dot">
    <ng-content></ng-content>
  </div>
</div>
